interface StepItem {
  step: number;
  label: string;
}

interface TemplateStepperProps {
  steps: StepItem[];
  currentStep: number;
}

const TemplateStepper = ({ steps, currentStep }: TemplateStepperProps) => {
  return (
    <div className="steps flex gap-4 justify-center mt-6">
      {steps.map(({ step, label }) => {
        const isActive = step === currentStep;
        const isCompleted = step < currentStep;
        const isUpcoming = step > currentStep;

        return (
          <div key={step} className="flex gap-2 items-center">
            {/* Circle */}
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center border transition-all
                ${isActive ? "text-[#1DB469] border-[#1DB469]" : ""}
                ${isCompleted ? "bg-[#1DB469] text-white border-none" : ""}
                ${isUpcoming ? "bg-[#F0F3F9] border-none text-gray-400" : ""}`}
            >
              {step}
            </div>

            {/* Label */}
            <div
              className={`text-sm font-medium transition-colors
                ${isActive ? "text-[#1DB469]" : ""}
                ${isCompleted ? "text-[#1DB469]" : ""}`}
            >
              {label}
            </div>
          </div>
        );
      })}
    </div>
  );
};
export default TemplateStepper;
